export const truncateString = (string: string, size: number) =>
    string?.length > size ? `${string.slice(0, size)}...` : string;
